
import { controls } from "../controls";


const demanddraftdetails = {
  label: "Demand Draft Details",
  pageLabel: "Demand Draft Details",
  starting: true,
  url: "demanddraftdetails",
  pageType: "history",
  formState: { checked: "view" },
  formActions: { edit: { allow: true }, delete: { allow: true } },
  // "Address.",
  form: [
    ...controls.displayText({ label: "Name Of Recipient", width: "col-sm-2", star: true }),
    ...controls.text({ width: "col-sm-2", isRequired: true, placeHolder: "Name Of Recipient", name: "name_of_recipient" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Total DD Amount", width: "col-sm-2" }),
    ...controls.numberOnly({ width: "col-sm-2", name: "total_dd_amount", placeHolder: "Total DD Amount", }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Paid Location", width: "col-sm-2" }),
    ...controls.text({ width: "col-sm-3", name: "paid_location", placeHolder: "Paid Location", }),
    ...controls.displayText({ width: "col-sm-1" }),
    ...controls.displayText({ label: "D.D. Internal/External", width: "col-sm-2", star: true }),
    ...controls.select({
      width: "col-sm-3", isRequired: true, name: "dd_internal_external", options: [{
        label: "Internal Demand Draft",
        value: "internal_demand_draft"
      }, {
        label: "External Demand Draft",
        value: "external_demand_draft"
      }]
    }),
    ...controls.displayText({ width: "col-sm-1" }),
    ...controls.displayText({ label: "Drawn On", width: "col-sm-2" }),
    ...controls.branch({ isRequired: true, star: true }),
    ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-2" }),

    ...controls.displayText({ label: "DD Amount", width: "col-sm-2", star: true }),
    ...controls.numberOnly({ width: "col-sm-2", data: "dd_amount", placeHolder: "DD Amount", isRequired: true }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Our Commission", width: "col-sm-2" }),
    ...controls.numberOnly({ width: "col-sm-2", name: "our_commission", placeHolder: "Our Commission" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "Their Commission", width: "col-sm-2" }),
    ...controls.numberOnly({ width: "col-sm-2", name: "their_commission", placeHolder: "Their Commission" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "GST", width: "col-sm-2 " }),
    ...controls.numberOnly({ width: "col-sm-2", name: "gst", placeHolder: "GST" }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ label: "DD Number", width: "col-sm-2", star: true }),
    ...controls.numberOnly({ width: "col-sm-2", name: "dd_number", placeHolder: "DD Number", isRequired: true }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ style: { textAlign: 'right' }, label: "Total", width: "col-sm-2", star: true }),
    ...controls.numtoword({
      name: "total", width: "col-sm-2", isRequired: true
    }),
    ...controls.displayText({ width: "col-sm-2" }),
    ...controls.displayText({ width: "col-sm-2", label: "Authorised Sign 1" }),
    ...controls.AuthorisedSign({ width: "col-sm-2" }),
    ...controls.showData({ width: "col-sm-2", data: "authorised_sign_display" }),
    ...controls.displayText({ width: "col-sm-2", label: "Authorised Sign 2" }),
    ...controls.AuthorisedSign({
      width: "col-sm-2", name: "authorised_sign_2", displayData: { Description: "authorised_sign_2_name_display", Refrid: "authorised_sign_2_guid" },
    }),
    ...controls.showData({ width: "col-sm-2", data: "authorised_sign_2_name_display" }),




  ]
}

export default demanddraftdetails;